<template>
  <div class="ui-container">
    <!-- 默认slot内容 -->
    <router-view :class="containerClass"></router-view>
    <!-- 全局loading组件 -->
    <loading :value="loading"></loading>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// 公有组件
import Loading from '@finance/ssvue/src/components/loading'

export default {
  components: {
    Loading
  },
  computed: {
    ...mapState({
      loading(state) {
        return state.common.loading
      },
      containerClass(state) {
        return state.common.containerClass
      }
    })
  },
}
</script>

<style lang="less">
@import "../assets/css/common.less";

@font-face {
  font-family: suiguanjia;
  src: url('../../static/font/Suiguanjia-Medium.otf');
}
.ui-container {
  width: 100%;
  height: 100%;
  background: #fff;
  /*overflow: scroll;*/
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left:0;
  top:0;
  max-width: 640px;
  margin: 0 auto;
}
.container {
    min-height: 100%;
    // background-color: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// App.vue?48ab5530